// set a question checkbox as selected
export function updateResponseArea(state, payload) {
  return {
    ...state,
    currentSection: updateResponseCurrentSection(
      state.currentSection,
      payload
    ),
  };
}

function updateResponseCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: updateResponseComponents(currentSection.components, payload),
  };
}

function updateResponseComponents(components, payload) {
  const updateComponent = (component) => {
    if (component.id === payload.componentID) {
      component = updateResponseOEQComponent(component, payload);
    }
    return component;
  };
  return components.map(updateComponent);
}

function updateResponseOEQComponent(component, payload) {
  component.responseArea = payload.responseArea;
  return component;
}
